"use client";

import { c as _c } from "react/compiler-runtime";
import { ChevronsUpDown, Check, Sparkles, Building2 } from "lucide-react";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useSidebar } from "@/components/ui/sidebar";
import type { Organization } from "@/lib/types";
interface OrganizationSwitcherProps {
  organizations: Organization[];
  selectedOrganization: Organization | null;
  onSelectOrganization: (org: Organization | null) => void;
}
export function OrganizationSwitcher(t0) {
  const $ = _c(49);
  const {
    organizations,
    selectedOrganization,
    onSelectOrganization
  } = t0;
  const [mounted, setMounted] = useState(false);
  const {
    isMobile,
    setOpenMobile
  } = useSidebar();
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setMounted(true);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== isMobile || $[3] !== onSelectOrganization || $[4] !== setOpenMobile) {
    t3 = org => {
      if (isMobile) {
        setOpenMobile(false);
      }
      onSelectOrganization(org);
    };
    $[2] = isMobile;
    $[3] = onSelectOrganization;
    $[4] = setOpenMobile;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleSelectOrganization = t3;
  const isChatPlanContext = !selectedOrganization || selectedOrganization.isChat;
  const activeClass = isChatPlanContext ? "" : "bg-accent text-accent-foreground";
  if (!mounted) {
    const t4 = `flex w-full min-w-0 items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium text-foreground hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background justify-start ${activeClass}`;
    let t5;
    if ($[6] !== isChatPlanContext) {
      t5 = isChatPlanContext ? <Sparkles className="h-4 w-4 flex-shrink-0 text-muted-foreground" /> : <Building2 className="h-4 w-4 flex-shrink-0 text-muted-foreground" />;
      $[6] = isChatPlanContext;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    const t6 = isChatPlanContext ? "Chat plan" : selectedOrganization.name;
    let t7;
    if ($[8] !== t6) {
      t7 = <span className="truncate">{t6}</span>;
      $[8] = t6;
      $[9] = t7;
    } else {
      t7 = $[9];
    }
    let t8;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <ChevronsUpDown className="ml-auto h-4 w-4 flex-shrink-0 opacity-50" />;
      $[10] = t8;
    } else {
      t8 = $[10];
    }
    let t9;
    if ($[11] !== t4 || $[12] !== t5 || $[13] !== t7) {
      t9 = <Button variant="ghost" disabled={true} className={t4}>{t5}{t7}{t8}</Button>;
      $[11] = t4;
      $[12] = t5;
      $[13] = t7;
      $[14] = t9;
    } else {
      t9 = $[14];
    }
    return t9;
  }
  const t4 = `flex w-full min-w-0 items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium text-foreground hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background justify-start ${activeClass}`;
  let t5;
  if ($[15] !== isChatPlanContext) {
    t5 = isChatPlanContext ? <Sparkles className="h-4 w-4 flex-shrink-0 text-muted-foreground" /> : <Building2 className="h-4 w-4 flex-shrink-0 text-muted-foreground" />;
    $[15] = isChatPlanContext;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const t6 = isChatPlanContext ? "Chat plan" : selectedOrganization.name;
  let t7;
  if ($[17] !== t6) {
    t7 = <span className="truncate">{t6}</span>;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ChevronsUpDown className="ml-auto h-4 w-4 flex-shrink-0 opacity-50" />;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t4 || $[21] !== t5 || $[22] !== t7) {
    t9 = <DropdownMenuTrigger asChild={true}><Button variant="ghost" className={t4}>{t5}{t7}{t8}</Button></DropdownMenuTrigger>;
    $[20] = t4;
    $[21] = t5;
    $[22] = t7;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== handleSelectOrganization) {
    t10 = () => handleSelectOrganization(null);
    $[24] = handleSelectOrganization;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  let t12;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Sparkles className="mr-2 h-4 w-4 flex-shrink-0 text-muted-foreground" />;
    t12 = <span className="truncate">Chat plan</span>;
    $[26] = t11;
    $[27] = t12;
  } else {
    t11 = $[26];
    t12 = $[27];
  }
  let t13;
  if ($[28] !== isChatPlanContext) {
    t13 = isChatPlanContext ? <Check className="ml-auto h-4 w-4 flex-shrink-0" /> : null;
    $[28] = isChatPlanContext;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t10 || $[31] !== t13) {
    t14 = <DropdownMenuItem onSelect={t10} className="cursor-pointer px-2 py-1.5 text-sm hover:bg-accent focus:bg-accent data-[highlighted]:bg-accent">{t11}{t12}{t13}</DropdownMenuItem>;
    $[30] = t10;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  let t16;
  let t17;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <DropdownMenuSeparator className="bg-border" />;
    t16 = <DropdownMenuLabel className="px-2 py-1.5 text-xs font-semibold text-muted-foreground">Organizations</DropdownMenuLabel>;
    t17 = <DropdownMenuSeparator className="bg-border" />;
    $[33] = t15;
    $[34] = t16;
    $[35] = t17;
  } else {
    t15 = $[33];
    t16 = $[34];
    t17 = $[35];
  }
  let t18;
  if ($[36] !== handleSelectOrganization || $[37] !== organizations || $[38] !== selectedOrganization?.id) {
    let t19;
    if ($[40] !== handleSelectOrganization || $[41] !== selectedOrganization?.id) {
      t19 = org_0 => <DropdownMenuItem key={org_0.id} onSelect={() => handleSelectOrganization(org_0)} className="cursor-pointer px-2 py-1.5 text-sm hover:bg-accent focus:bg-accent data-[highlighted]:bg-accent"><Building2 className="mr-2 h-4 w-4 flex-shrink-0 text-muted-foreground" /><span className="truncate">{org_0.name}</span>{selectedOrganization?.id === org_0.id && <Check className="ml-auto h-4 w-4 flex-shrink-0" />}</DropdownMenuItem>;
      $[40] = handleSelectOrganization;
      $[41] = selectedOrganization?.id;
      $[42] = t19;
    } else {
      t19 = $[42];
    }
    t18 = organizations.map(t19);
    $[36] = handleSelectOrganization;
    $[37] = organizations;
    $[38] = selectedOrganization?.id;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[43] !== t14 || $[44] !== t18) {
    t19 = <DropdownMenuContent className="w-60 border-border bg-background text-foreground shadow-xl">{t14}{t15}{t16}{t17}{t18}</DropdownMenuContent>;
    $[43] = t14;
    $[44] = t18;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== t19 || $[47] !== t9) {
    t20 = <><DropdownMenu>{t9}{t19}</DropdownMenu></>;
    $[46] = t19;
    $[47] = t9;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  return t20;
}